/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppAiAgentConfigStorePathParams,
	WhatsAppAiAgentConfigStoreRequest,
	WhatsAppAiAgentConfigStoreResponse,
} from '../types/WhatsAppAiAgentConfigStore'

/**
 * POST /campaigns/:campaignId/whatsapp-ai-config
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::store
 */
export async function whatsAppAiAgentConfigStore(
	campaignId: WhatsAppAiAgentConfigStorePathParams['campaignId'],
	data: WhatsAppAiAgentConfigStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppAiAgentConfigStoreResponse>> {
	return axiosInstance.post(`/campaigns/${campaignId}/whatsapp-ai-config`, data, config)
}
